import styled from 'styled-components';

import { getThemeColor, getThemeTransition } from '@utils/styled';

import Typography from '@common/components/Typography';

const COUNTER_HEIGHT = 6;
const COUNTER_MARGIN_BOTTOM = 2;

export const CounterWrapper = styled.div`
  position: sticky;
  right: 0;
  bottom: calc(2rem + env(safe-area-inset-bottom));
  left: 0;
  z-index: ${({ isRemovedFromDOM }) => (isRemovedFromDOM ? '-1' : '2')};
  visibility: ${({ isRemovedFromDOM }) =>
    isRemovedFromDOM ? 'hidden' : 'visible'};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  display: flex;
  align-items: center;
  width: 27rem;
  height: ${`${COUNTER_HEIGHT}rem`};
  box-shadow: ${({ theme }) => theme.shadows[0]};
  margin-top: ${`-${COUNTER_HEIGHT + COUNTER_MARGIN_BOTTOM}rem`};
  margin-right: auto;
  margin-bottom: ${`${COUNTER_MARGIN_BOTTOM}rem`};
  margin-left: auto;
  border-radius: 3rem;
  padding: 1rem 1.8rem 1rem 1rem;
  background-color: ${getThemeColor('grey.100')};
  will-change: transform, opacity;
  transition: ${getThemeTransition('opacity', 'fast')},
    ${getThemeTransition('transform', 'fast')};
`;

export const CloseButton = styled.button`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0;
  border: none;
  border-radius: 50%;
  padding: 0;
  background-color: ${getThemeColor('bluegrey.90')};
  color: ${getThemeColor('bluegrey.60')};
  transition: ${getThemeTransition('fill')},
    ${getThemeTransition('background-color')};
  cursor: pointer;

  &:hover {
    background-color: ${getThemeColor('grey.80')};
  }

  svg {
    width: 1.1rem;
    height: 1.1rem;
    margin: auto;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: ${getThemeColor('bluegrey.90')};

  svg {
    width: 2rem;
  }
`;

export const Content = styled(Typography).attrs({ variant: 'body4' })`
  flex-grow: 1;
  margin: 0;
  padding: 0 1rem;
  word-break: break-word;
  hyphens: none;
`;
